/*
 * Created by jmeo at 2021-06-02
 * FileName: PlatformAgreement.tsx
 * 平台用户协议
 */

import {setTitle} from "@src/util";
import CustomScroll from '@src/component/customScroll'
export default function () {
    setTitle('平台用户协议')
    return <div className="page bottomFit"><CustomScroll><div className="agreement">
        <h2>平 台 用 户 协 议</h2>
        <br/>
        <h3>总则</h3>
        <br/>
        <p>润雨同舟（深圳）融资租赁有限公司联合浙江春风动力股份有限公司，利用自身的技术以及网络平台，为用户提供摩托车及周边产品销售及金融购车方案综合服务。</p>
        <p>如您拒绝接受本协议，请立刻停止访问本网站及使用本网站提供的服务。如果您继续访问、浏览、预定或使用本网站提供的服务时，即视为您接受本协议内容。</p>
        <p><strong>特别提醒：本协议条款包含双方的权利义务的约定，涉及高价值商品的交易及金融服务内容，请使用者务必详细阅读，并充分理解本协议全部条款。</strong></p>
        <br/>
        <h4>服务协议</h4>
        <br/>
        <p>一、用户通过CFMOTO APP页面注册程序，成为本网站会员，并可使用本网站提供的内容、资讯与金融服务。</p>
        <p>二、本网站作为品牌宣传、资讯传播及金融服务产品内容展示及销售平台，具体摩托车产品由实际生产商或经销商提供并承担责任，金融服务产品由润雨同舟（深圳）融资租赁有限公司提供并承担相应的责任和义务。</p>
        <p>
            三、用户在本网站页面下单购买摩托车，本网站仅依据客户选择的金融服务方案，履行代为支付购车款义务，代支付的购车款最终将支付到经销商，由经销商提供有效发票和报销凭证。由此产生的商品质量问题、投诉与纠纷，应由用户与第三方自行解决，但本网站作为金融方案提供商，当用户未行使权利时，有权代位向第三方追究产品责任。</p>
        <p>四、本网站页面展示的摩托车商品，是作为综合资讯服务进行展示，实际购车款由第三方公司收取。</p>
        <p>五、用户采用润雨同舟提供的金融服务产品购买第三方摩托车经销商（包括但不限于春风品牌及春风指定品牌的车辆）销售的车辆时，用户同意授权润雨同舟获得该车辆信息、包括但不限于车主身份资料、经销商信息、登记注册信息、购车发票信息、车辆位置信息、车辆行驶轨迹、车辆保险情况等相关资料。</p>
        <p>六、双方权利和义务</p>
        <p>
            1、用户通过注册成为本网站会员，有权利访问本页面提供的内容和资讯，通过本页面展示的链接，选择本网站提供的金融服务产品购买第三方提供的摩托车及周边产品。用户在注册本网站会员时，承诺提供的个人资料属实，不得冒用他人身份信息，否则本网站有权封停、注销用户账户，必要时有权解除双方签订的金融方案服务合同，并依法追究因用户提供的不实资料所带来的民事和刑事责任。</p>
        <p> 2、用户应遵守法律法规的相关条款，不得在本网站发布非法内容，包括但不限于以下项目：</p>
        <p className="tip">（1）违反宪法或法律法规规定的；</p>
        <p className="tip">（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>
        <p className="tip">（3）损害国家荣誉和利益的，损害公共利益的；</p>
        <p className="tip">（4）煽动民族仇恨、民族歧视，破坏民族团结的；</p>
        <p className="tip">（5）破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
        <p className="tip">（6）散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
        <p className="tip">（7）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</p>
        <p className="tip">（8）侮辱或者诽谤他人，侵害他人合法权益的；</p>
        <p className="tip">（9）含有法律、行政法规禁止的其他内容的。</p>
        <p>否则本网站有权利对上述内容进行修改、删除，暂时或永久封停用户账户或登录IP。</p>
        <p> 3、用户不得利用已知和未知的程序漏洞、非法获得的权限或其他一切技术手段对本网站页面、数据库进行私自篡改，否则本网站有权追究侵害者的侵权责任。</p>
        <p> 4、本网站有权对展示内容随时进行增加、删除或修改。</p>
        <p> 5、本网站为面向广大用户提供更优质的产品浏览服务，会定期或不定期对网站页面、数据库和硬件设备进行维护调试，由此导致用户不能访问、下单所造成的损失，本网站不承担赔偿责任。</p>
        <p> 6、用户的个人资料及发布的信息中，不得含有未经本网站许可的广告宣传内容，否则本网站有权暂停或注销用户账户。</p>
        <br/>
        <br/>
        <h4>知识产权声明</h4>
        <br/>
        <p>
            润雨同舟金融服务和CFMOTO平台及产品所有文案、原创摄影照片、图形设计、原创视频内容、配色方案、排版方式、统计数据、动画等，及以上元素单独或组合的知识产权全部归润雨同舟（深圳）融资租赁有限公司所有。未经许可，任何人不得拷贝、下载、拍摄、录制。否则润雨同舟（深圳）融资租赁有限公司有权依法追究其侵权责任。由第三方提供的图片、视频、文字资料等作品的知识产权归提供方所有，如因此侵犯他人的合法权益，应由提供方承担全部责任。</p>
        <p>隐私政策</p>
        <p>
            润雨同舟（深圳）融资租赁有限公司尊重并重视用户隐私保护，用户在点击本用户协议“确认”按键的时候，即表示允许本网站按以下方式使用用户提交的个人信息。本网站本着“相关、合理、必要”的原则，在下列范围内使用用户提供的个人资料信息。</p>
        <p>一、本网站会根据用户提交的身份信息、以往的购买记录、银行账户资料，为用户推荐使用本网站的各项服务。</p>
        <p>二、本网站会将用户提交的个人资料提供给合作的第三方摩托车厂商及周边商品提供商、银行或保险机构，以便能够按照客户选定的金融服务方案提供相应服务，并保障双方的合法权益。同时，为给用户提供更好的服务以及协助用户办理完成金融服务手续，本网站会将用户提交的联系方式及用户办理金融服务手续的进度情况同步给厂商及经销商，以便厂商或经销商协助用户办理金融服务手续。</p>
        <p>三、本网站可以对用户提交的个人资料进行分析，隐名以后用于商业用途。</p>
        <p>四、本网站可以将用户的个人资料、购买记录、支付信息、车辆型号、行驶轨迹等数据，交由第三方合作公司<strong>（润雨同舟（深圳）融资租赁有限公司、远东宏信普惠融资租赁（天津）有限公司等）</strong>，共同对数据进行分析利用，以便更合理高效的为用户提供后续服务。</p>
        <p>五、用户允许本网站及合作公司向用户提供的电子邮箱或电话发送产品动态、交易确认、身份验证及其他相关信息。</p>
        <p>六、用户允许本网站及合作公司向用户提供的移动电话号码或社交软件号码发送验证信息、服务通知、交易确认等信息。</p>
        <p>七、应司法、行政等监管部门的要求，本网站可以提供用户的个人资料、行程记录、购买记录、支付信息等资料。</p>
        <p>
            八、用户可以修改自己提供的个人信息，但应保证其真实性。用户自行上传和更改的信息，不得侵犯任意第三方的合法权益，否则本网站有权不经通知，对用户上传的违法违规信息进行修改、删除，直至暂时或永久性封停用户账户和登录IP。因此给本网站造成损失的，本网站有权向用户追偿。</p>
        <p>除以上范围外，本网站将妥善保管用户的个人隐私信息，避免外泄。</p>
        <p>本网站根据商业合作的原则，与其他网站建立了合作关系。当用户点击链接进入其他网站或微信小程序、公众号时，本网站的隐私协议将不再生效。</p>
        <h4>免责声明</h4>
        <br/>
        <p>一、本网站所展示的各品牌摩托车及周边商品宣传资料、行业资讯由实际生产商或经销商提供，本网站对其真实性不承担责任。</p>
        <p>二、因生产商或经销商对产品进行的改款、升级、停产、调整价格等行为，本网站无法预计、无法避免的因素，造成用户最终获得的商品与本网站描述内容不符的，本网站不承担责任。</p>
        <p>三、因商品生产商或经销商制造、仓储、运输、售后等造成的商品瑕疵，本公司不承担责任。当用户合法权益受到损害，而怠于行使追偿权利时，本网站作为金融服务提供方，有权代位行使追偿权。</p>
        <p>四、因为通信提供商或用户自己的通信终端的原因，造成用户无法访问本网站的，本网站不承担责任。</p>
        <p>五、因为硬件故障、硬件设备托管机构、通信线路提供商、黑客入侵等因素造成用户在本网站的资料数据灭失的，本站不承担责任。</p>
        <br/>
        <br/>
        <h4>争议及管辖</h4>
        <br/>
        <p>因本协议发生的纠纷及争议，受中华人民共和国法律管辖。</p>
        <p>用户与本网站因本协议发生纠纷，可友好协商解决。协商不成的，任何一方可向润雨同舟（深圳）融资租赁有限公司所在地人民法院提起诉讼。</p>
        <p>本协议部分条款如因某些原因导致无效，不影响其他条款的效力。</p>
        <br/>
        <br/>

    </div></CustomScroll></div>
}
